import { render, staticRenderFns } from "./Time.vue?vue&type=template&id=5a14a208&scoped=true&"
import script from "./Time.vue?vue&type=script&lang=ts&"
export * from "./Time.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a14a208",
  null
  
)

export default component.exports